function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class PollingClock {
    subscribe(callback) {
        const wasEmpty = this.subscribers.size === 0;
        this.subscribers.add(callback);
        if (wasEmpty) {
            this.start();
        }
        return ()=>{
            this.subscribers.delete(callback);
            if (this.subscribers.size === 0) {
                this.stop();
            }
        };
    }
    destroy() {
        this.stop();
        this.subscribers.clear();
    }
    start() {
        if (this.intervalId !== null) {
            return;
        }
        this.intervalId = setInterval(()=>{
            this.tick();
        }, PollingClock.TICK_INTERVAL_MS);
        if (typeof document !== 'undefined') {
            document.addEventListener('visibilitychange', this.handleVisibilityChange);
        }
    }
    stop() {
        if (this.intervalId !== null) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
        if (typeof document !== 'undefined') {
            document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        }
        this.pausedAt = null;
    }
    tick() {
        if (this.pausedAt !== null) {
            return;
        }
        const tickTime = Date.now();
        this.subscribers.forEach((callback)=>{
            callback.onTick(tickTime);
        });
    }
    constructor(){
        _define_property(this, "subscribers", new Set());
        _define_property(this, "intervalId", null);
        _define_property(this, "pausedAt", null);
        _define_property(this, "handleVisibilityChange", ()=>{
            if (typeof document === 'undefined') {
                return;
            }
            if (document.visibilityState === 'hidden') {
                this.pausedAt = Date.now();
            } else if (document.visibilityState === 'visible' && this.pausedAt !== null) {
                const elapsedMs = Date.now() - this.pausedAt;
                this.pausedAt = null;
                this.subscribers.forEach((callback)=>{
                    if (callback.onVisibilityResume) {
                        callback.onVisibilityResume(elapsedMs);
                    }
                });
            }
        });
    }
}
_define_property(PollingClock, "TICK_INTERVAL_MS", 1000);
export { PollingClock as default };

//# sourceMappingURL=PollingClock.js.map